export default __webpack_public_path__ + "static/media/flower.18cb8592.jpg";